import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation UpdateCustomerPaymentMethod($customerId: ID!, $stripePaymentMethodId: ID!) {
    updateCustomerPaymentMethod(
      customerId: $customerId
      stripePaymentMethodId: $stripePaymentMethodId
    ) {
      card {
        brand
      }
    }
  }
`;

export const updateCustomerPaymentMethod = (customerId, stripePaymentMethodId) =>
  executeGqlMutation({
    mutation: MUTATION,
    variables: {
      customerId,
      stripePaymentMethodId,
    },
  }).then(({ data }) => getSingleProp(data));
